import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { formatApiError, useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen brand-glow grain relative flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="absolute inset-0 bg-[#0a0a0a]/50" />
      <form onSubmit={submit} className="relative w-full max-w-md bg-black border border-white/10 p-8 md:p-10 space-y-5" data-testid="admin-login-form">
        <img src="/brand/logo.png" alt="LEGROSTASDEZIK" className="h-12 w-auto" />
        <h1 className="font-thin-brand uppercase text-3xl text-white flex items-center gap-3"><Lock className="w-6 h-6 text-primary" /> Espace admin</h1>
        <Input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12" data-testid="admin-login-email" />
        <Input type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12" data-testid="admin-login-password" />
        {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-primary text-white font-display uppercase text-lg py-4 hover:bg-white hover:text-black transition-colors duration-200 disabled:opacity-60 flex items-center justify-center gap-2">
          {loading && <Loader2 className="w-5 h-5 animate-spin" />} Se connecter
        </button>
      </form>
    </div>
  );
}
